(function() {
    'use strict';

    var observer = null;

    function checkAddToCartVisibility() {
        var addToCartButton = document.querySelector('.pdp-addtocart');

        // Clean up existing observer
        if (observer) {
            observer.disconnect();
            observer = null;
        }

        if (!addToCartButton) {
            return;
        }

        // Create intersection observer to watch the add to cart button
        observer = new IntersectionObserver(
            function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        // Button is visible, remove class
                        document.body.classList.remove('off-atc');
                    } else {
                        // Button is NOT visible, add class
                        document.body.classList.add('off-atc');
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            }
        );

        observer.observe(addToCartButton);
    }

    /**
     * When quantity-input changes: set active on the .jspg-qty whose data-jsp-count is the
     * largest value <= quantity (e.g. qty 5 → active data-jsp-count=4, not 2 or 1).
     */
    function syncActivePackSizeFromQuantity() {
        var form = document.querySelector('form.fs-product-form');
        if (!form) return;

        var qtyInput = form.querySelector('.qty-ad-wrap .quantity-input') || form.querySelector('.quantity-input');
        if (!qtyInput) return;

        var quantity = parseInt(qtyInput.value, 10) || 1;
        var allPackOptions = form.querySelectorAll('.jspg-qty');
        if (!allPackOptions.length) return;

        var best = null;
        var bestCount = 0;
        for (var i = 0; i < allPackOptions.length; i++) {
            var count = parseInt(allPackOptions[i].getAttribute('data-jsp-count'), 10);
            if (!isNaN(count) && count <= quantity && count >= bestCount) {
                bestCount = count;
                best = allPackOptions[i];
            }
        }
        if (!best) return;

        var parent = best.parentElement;
        if (parent) {
            var siblings = parent.querySelectorAll('.jspg-qty');
            for (var j = 0; j < siblings.length; j++) {
                siblings[j].classList.remove('active');
            }
        }
        best.classList.add('active');
    }

    function formatMoneyCents(cents) {
        return (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function')
            ? window.Shopify.formatMoney(cents) : ('$' + (cents / 100).toFixed(2));
    }

    function formatCompareMoney(cents) {
        return '$' + Math.round(cents / 100);
    }

    /**
     * Update add-to-cart button price (all .addtocart .pr) based on quantity and active pack size.
     * When .jspg-qty is present: use active .jspg-qty data-jsp-price (and data-jsp-discount for compare).
     * When .jspg-qty is not available: use selected option's data-price from .pr-variants select.
     */
    function updateAddToCartPriceWithQuantity() {
        var form = document.querySelector('form.fs-product-form');
        if (!form) return;

        var qtyInput = form.querySelector('.qty-ad-wrap .quantity-input') || form.querySelector('.quantity-input');
        if (!qtyInput) return;

        var qty = parseInt(qtyInput.value, 10) || 1;
        var unitPriceCents = 0;
        var hasCompare = false;
        var comparePriceHtml = '';

        var activeQty = form.querySelector('.jspg-qty.active');
        if (activeQty) {
            unitPriceCents = parseInt(activeQty.getAttribute('data-jsp-price'), 10);
            var discountPct = parseInt(activeQty.getAttribute('data-jsp-discount'), 10);
            hasCompare = !isNaN(discountPct) && discountPct > 0 && discountPct < 100;
        }

        if (!activeQty || isNaN(unitPriceCents) || unitPriceCents <= 0) {
            var selectBox = form.querySelector('.pr-variants');
            if (selectBox && selectBox.options && selectBox.options.length) {
                var selectedOption = selectBox.options[selectBox.selectedIndex];
                if (selectedOption) {
                    unitPriceCents = parseInt(selectedOption.getAttribute('data-price'), 10);
                }
            }
        }

        if (isNaN(unitPriceCents) || unitPriceCents <= 0) return;

        var totalCents = unitPriceCents * qty;
        var displayPrice = formatMoneyCents(totalCents);

        comparePriceHtml = displayPrice;
        if (activeQty && hasCompare) {
            var compareUnitCents = Math.round(unitPriceCents * 100 / parseInt(activeQty.getAttribute('data-jsp-discount'), 10));
            var compareTotalCents = compareUnitCents * qty;
            comparePriceHtml = displayPrice + ' <s>' + formatCompareMoney(compareTotalCents) + '</s>';
        }

        var mainPr = form.querySelector('.addtocart .pr');
        if (mainPr) mainPr.innerHTML = '| ' + comparePriceHtml;
        var stickyPr = document.querySelector('.product-form-sticky-button__btn .pr');
        if (stickyPr) stickyPr.innerHTML = '| ' + comparePriceHtml;

        var afterpayCents = Math.round(totalCents / 4);
        var afterpayFormatted = formatMoneyCents(afterpayCents);
        var afterpayEls = document.querySelectorAll('.afterpay-price');
        for (var a = 0; a < afterpayEls.length; a++) {
            afterpayEls[a].textContent = afterpayFormatted;
        }
    }

    function init() {
        // Initial check
        checkAddToCartVisibility();

        // Watch for form container changes (AJAX loaded content)
        var formContainer = document.querySelector('.sp-product-form-container');
        if (formContainer) {
            var formMutationObserver = new MutationObserver(function() {
                // Re-check when form content changes
                setTimeout(function() {
                    checkAddToCartVisibility();
                }, 200);
            });

            formMutationObserver.observe(formContainer, {
                childList: true,
                subtree: true
            });
        }

        // Single delegated click handler: bundle (theme), sticky button, quantity +/- 
        document.body.addEventListener('click', function(e) {
            var target = e.target;

            // 1. .qw-click: trigger quote link
            if (target.closest && target.closest('.qw-click')) {
                var quoteLink = document.querySelector('.pdp-fs-quote-link');
                if (quoteLink) quoteLink.click();
                return;
            }

            // 2. Sticky button: submit form
            var stickyButton = target.closest && target.closest('.product-form-sticky-button__btn');
            if (stickyButton) {
                e.preventDefault();
                if (!stickyButton.disabled) {
                    var form = document.querySelector('form.fs-product-form');
                    if (form) {
                        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    }
                }
                return;
            }

            // 3. Quantity plus/minus for .sbp-qty
            var quantityButton = target.closest && target.closest('.sbp-qty .quantity-plus, .sbp-qty .quantity-minus');
            if (quantityButton) {
                e.preventDefault();
                var sbpQty = quantityButton.closest('.sbp-qty');
                var quantityInput = sbpQty && sbpQty.querySelector('.quantity-input');
                if (quantityInput) {
                    var currentValue = parseInt(quantityInput.value, 10) || 1;
                    var minValue = parseInt(quantityInput.getAttribute('min'), 10) || 1;
                    var maxValue = parseInt(quantityInput.getAttribute('max'), 10) || 999;
                    var newValue = quantityButton.classList.contains('quantity-plus')
                        ? Math.min(currentValue + 1, maxValue)
                        : Math.max(currentValue - 1, minValue);
                    if (newValue !== currentValue) {
                        quantityInput.value = newValue;
                        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
                return;
            }

            // 4. Product option (.jspg-product): fetch and replace form
            if (target.closest && target.closest('.jspg-product')) {
                e.preventDefault();
                var clicked = target.closest('.jsp-gitem');
                var currentFormContainer = clicked.closest('.sp-product-form-container');
                var keptValue = null;
                if (currentFormContainer) {
                    var firstOSelected = currentFormContainer.querySelector('[data-oselected-value]');
                    if (firstOSelected) {
                        keptValue = firstOSelected.getAttribute('data-oselected-value');
                    }
                }
                var href = clicked.getAttribute('href');
                if (href) {
                    fetch(href)
                        .then(function(response) { return response.text(); })
                        .then(function(html) {
                            var tempDiv = document.createElement('div');
                            tempDiv.innerHTML = html;
                            var newFormContainer = tempDiv.querySelector('.sp-product-form-container');
                            if (newFormContainer && currentFormContainer) {
                                currentFormContainer.innerHTML = newFormContainer.innerHTML;
                                if (keptValue !== null) {
                                    var firstOSelectedNew = currentFormContainer.querySelector('[data-oselected-value]');
                                    if (firstOSelectedNew) {
                                        var matchingChild = firstOSelectedNew.querySelector('[data-o-value][data-o-value="' + keptValue + '"]');
                                        if (matchingChild) {
                                            matchingChild.click();
                                        }
                                    }
                                }
                            }
                            var a = document.createElement('a');
                            a.href = href;
                            window.history.replaceState({}, '', a.pathname);
                        })
                        .catch(function(err) { console.error('Error fetching product form:', err); });
                }
                return;
            }

            // 5. Quantity / pack-size option (.jspg-qty)
            if (target.closest && target.closest('.jspg-qty')) {
                e.preventDefault();
                var clickedQty = target.closest('.jspg-qty');
                var jspCount = clickedQty.getAttribute('data-jsp-count');
                var qtyParent = clickedQty.parentElement;
                if (qtyParent) {
                    var qtySiblings = qtyParent.querySelectorAll('.jspg-qty');
                    qtySiblings.forEach(function(sib) { sib.classList.remove('active'); });
                }
                clickedQty.classList.add('active');
                var form = clickedQty.closest('form');
                if (form) {
                    var qtyInput = form.querySelector('.qty-ad-wrap .quantity-input');
                    if (qtyInput && jspCount !== null) {
                        qtyInput.value = jspCount;
                    }
                }
                updateAddToCartPriceWithQuantity();
                setTimeout(function() { checkAddToCartVisibility(); }, 300);
                return;
            }

            // 6. Other bundle option (.jsp-gitem): re-check add-to-cart visibility
            if (target.closest && target.closest('.jsp-gitem')) {
                setTimeout(function() {
                    checkAddToCartVisibility();
                }, 300);
            }
        });

        // Handle manual quantity input changes (min/max validation + update button price)
        document.body.addEventListener('change', function(e) {
            var target = e.target;
            if (!target || !target.classList.contains('quantity-input')) {
                return;
            }
            var sbpQty = target.closest('.sbp-qty');
            if (!sbpQty) {
                return;
            }
            var minValue = parseInt(target.getAttribute('min'), 10) || 1;
            var maxValue = parseInt(target.getAttribute('max'), 10) || 999;
            var inputValue = parseInt(target.value, 10);
            if (isNaN(inputValue) || inputValue < minValue) {
                target.value = minValue;
            } else if (inputValue > maxValue) {
                target.value = maxValue;
            }
            syncActivePackSizeFromQuantity();
            updateAddToCartPriceWithQuantity();
        });

        // When pr-variants (variant select) changes: recompute .jspg-qty data-jsp-price from selected option data-price and each item's data-jsp-discount
        document.body.addEventListener('change', function(e) {
            if (!e.target || !e.target.classList || !e.target.classList.contains('pr-variants')) return;
            var selectBox = e.target;
            var form = selectBox.closest('form');
            if (!form) return;
            var selectedOption = selectBox.options[selectBox.selectedIndex];
            if (!selectedOption) return;
            var variantPriceCents = parseInt(selectedOption.getAttribute('data-price'), 10);
            if (isNaN(variantPriceCents) || variantPriceCents <= 0) return;
            var packItems = form.querySelectorAll('.jspg-qty');
            for (var i = 0; i < packItems.length; i++) {
                var el = packItems[i];
                var discountPct = parseInt(el.getAttribute('data-jsp-discount'), 10);
                if (isNaN(discountPct) || discountPct <= 0) discountPct = 100;
                var newPrice = Math.round(variantPriceCents * discountPct / 100);
                el.setAttribute('data-jsp-price', String(newPrice));
            }
            var qtyInput = form.querySelector('.qty-ad-wrap .quantity-input') || form.querySelector('.quantity-input');
            if (qtyInput) {
                setTimeout(function() {
                    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
                }, 200);
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Also check after a delay to ensure button is loaded
    setTimeout(checkAddToCartVisibility, 500);
})();
